import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import RefreshIcon from 'icons/Refresh.icon';
import PlusIcon from 'icons/Plus.icon';

import './ActivateSecureLinkModal.styles.scss';

type ActivateSecureLinkModalProps = {
  className?: string;
  onActivate: () => void;
  onAddFiles: () => void;
} & ModalProps;

const ActivateSecureLinkModal: React.ForwardRefRenderFunction<
  ModalRef,
  ActivateSecureLinkModalProps
> = (props, ref) => {
  const { className, onActivate, onAddFiles, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('activate-secure-link-modal', className);

  const { t } = useTranslation();

  const hanldeOnActivate = useCallback(() => {
    onActivate();
    modal?.close();
  }, [modal, onActivate]);

  const hanldeOnAddFiles = useCallback(() => {
    onAddFiles();
    modal?.close();
  }, [modal, onAddFiles]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('activateSecureLink')}
      {...rest}
    >
      <p>{t('activateSecureLinkDescription')}</p>
      <div className="actions">
        <Button variant="outline" icon={RefreshIcon} onClick={hanldeOnActivate}>
          {t('activateLinkWithoutFiles')}
        </Button>
        <Button icon={PlusIcon} onClick={hanldeOnAddFiles}>
          {t('addFilesAndActivate')}
        </Button>
      </div>
    </Modal>
  );
};

export default forwardRef(ActivateSecureLinkModal);
